
export default {
  state: {
    user: {
      userName: 'imatest_user',
      name_user: 'Arturo Emmanuel Reséndiz Aguilar',
      email: 'myticket@example.com',
      datebirth: '18/10/1993',
      genre: 'Masculino',
      createdAt: '00/10/17',
      favCategory: 'Deportes',
      iconCategory: '/static/images/sports-icon.svg',
      numEvents: 6,
      lastEventImg: '/static/images/event-arts-full.jpg',
      nameEvent: 'Cirque du Soleil: Totem'
    }

  },
  mutations: {

  },
  actions: {

  },
  getters: {
    getUser (state) {
      return state.user
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/profile.store.js